import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { GalleryPage } from './pages/GalleryPage';
import { ImageDetailPage } from './pages/ImageDetailPage';
import { UploadPage } from './pages/UploadPage';
import { SchedulingPage } from './pages/SchedulingPage';
import { CollectionsPage } from './pages/CollectionsPage';
import { CollectionDetailPage } from './pages/CollectionDetailPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { ComparePage } from './pages/ComparePage';
import { DisasterDashboardPage } from './pages/DisasterDashboardPage';
import { MaritimeDashboardPage } from './pages/MaritimeDashboardPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/image/:id" element={<ImageDetailPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/scheduling" element={<SchedulingPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/collection/:id" element={<CollectionDetailPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/disasters" element={<DisasterDashboardPage />} />
          <Route path="/maritime" element={<MaritimeDashboardPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
